var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinemanGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4594 64.124C45.1097 64.124 52.122 63.1479 52.122 61.9438C52.122 60.7398 45.1097 59.7637 36.4594 59.7637C27.8092 59.7637 20.7968 60.7398 20.7968 61.9438C20.7968 63.1479 27.8092 64.124 36.4594 64.124Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8889 110.022H10.3933L12.7647 90.477C13.1472 87.4171 15.0978 84.7589 17.9282 83.5158C21.6765 81.8903 26.8974 80.2265 31.5254 78.9643L42.0628 78.926C46.7291 80.1882 51.7969 81.852 55.4305 83.4967C58.2035 84.7589 60.1159 87.3789 60.4984 90.4005L62.8889 110.022Z",
    fill: "url(#paint0_linear_5140_23626)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3114 73.8965V79.1174C42.3114 79.1174 41.2787 84.9502 36.4403 85.9255C31.3915 84.606 30.6266 79.1174 30.6266 79.1174V73.8965H42.3114Z",
    fill: "#EAEAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1689 67.0882C48.4681 67.0882 49.5212 65.821 49.5212 64.2579C49.5212 62.6947 48.4681 61.4275 47.1689 61.4275C45.8698 61.4275 44.8167 62.6947 44.8167 64.2579C44.8167 65.821 45.8698 67.0882 47.1689 67.0882Z",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0942 66.8587C27.3933 66.8587 28.4464 65.5915 28.4464 64.0284C28.4464 62.4652 27.3933 61.198 26.0942 61.198C24.7951 61.198 23.7419 62.4652 23.7419 64.0284C23.7419 65.5915 24.7951 66.8587 26.0942 66.8587Z",
    fill: "#EAEAEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6266 76.2104C32.2904 78.0272 34.3366 79.232 36.5359 79.232C38.6778 79.232 40.6667 78.0846 42.3114 76.3443V73.9155H30.6266V76.2104Z",
    fill: "#EAEAEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3046 60.5288V64.258C26.3046 69.9187 30.8944 77.9126 36.5551 77.9126C42.2158 77.9126 46.8056 69.9187 46.8056 64.258V60.5288H26.3046Z",
    fill: "#EAEAEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.805 94.5505H19.4581V110.041H53.805V94.5505Z",
    fill: "url(#paint1_linear_5140_23626)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2473 94.5505V80.5134C24.7938 80.9724 23.3595 81.4505 22.0017 81.9286V94.5505H26.2473Z",
    fill: "#EAEAEA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3954 94.5504V81.8711C50.0376 81.3739 48.6033 80.8767 47.1498 80.4177V94.5504H51.3954Z",
    fill: "#EAEAEA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8351 61.8101H52.1986C51.8735 61.3893 50.5157 59.6682 49.1005 59.0944C49.1005 59.0944 49.7698 45.2869 36.5551 45H36.536H36.5169C23.3021 45.2869 23.9715 59.0944 23.9715 59.0944C22.4989 59.6682 21.1411 61.3893 20.8351 61.8101Z",
    fill: "#EAEAEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.459 64.124C145.11 64.124 152.122 63.1479 152.122 61.9438C152.122 60.7398 145.11 59.7637 136.459 59.7637C127.809 59.7637 120.797 60.7398 120.797 61.9438C120.797 63.1479 127.809 64.124 136.459 64.124Z",
    fill: "#EAEAEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.889 110.022H110.393L112.765 90.477C113.147 87.4171 115.098 84.7589 117.928 83.5158C121.677 81.8903 126.897 80.2265 131.525 78.9643L142.063 78.926C146.729 80.1882 151.797 81.852 155.431 83.4967C158.204 84.7589 160.116 87.3789 160.498 90.4005L162.889 110.022Z",
    fill: "url(#paint2_linear_5140_23626)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.311 73.8965V79.1174C142.311 79.1174 141.279 84.9502 136.44 85.9255C131.392 84.606 130.627 79.1174 130.627 79.1174V73.8965H142.311Z",
    fill: "#EAEAEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.169 67.0882C148.468 67.0882 149.521 65.821 149.521 64.2579C149.521 62.6947 148.468 61.4275 147.169 61.4275C145.87 61.4275 144.817 62.6947 144.817 64.2579C144.817 65.821 145.87 67.0882 147.169 67.0882Z",
    fill: "#EAEAEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.094 66.8587C127.393 66.8587 128.446 65.5915 128.446 64.0284C128.446 62.4652 127.393 61.198 126.094 61.198C124.795 61.198 123.742 62.4652 123.742 64.0284C123.742 65.5915 124.795 66.8587 126.094 66.8587Z",
    fill: "#EAEAEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.627 76.2104C132.29 78.0272 134.337 79.232 136.536 79.232C138.678 79.232 140.667 78.0846 142.311 76.3443V73.9155H130.627V76.2104Z",
    fill: "#EAEAEA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.305 60.5288V64.258C126.305 69.9187 130.894 77.9126 136.555 77.9126C142.216 77.9126 146.806 69.9187 146.806 64.258V60.5288H126.305Z",
    fill: "#EAEAEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.805 94.5505H119.458V110.041H153.805V94.5505Z",
    fill: "url(#paint3_linear_5140_23626)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.247 94.5505V80.5134C124.794 80.9724 123.36 81.4505 122.002 81.9286V94.5505H126.247Z",
    fill: "#EAEAEA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M151.395 94.5504V81.8711C150.038 81.3739 148.603 80.8767 147.15 80.4177V94.5504H151.395Z",
    fill: "#EAEAEA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.835 61.8101H152.199C151.874 61.3893 150.516 59.6682 149.101 59.0944C149.101 59.0944 149.77 45.2869 136.555 45H136.536H136.517C123.302 45.2869 123.971 59.0944 123.971 59.0944C122.499 59.6682 121.141 61.3893 120.835 61.8101Z",
    fill: "#EAEAEA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0879 59.8135C101.383 59.8135 113.781 58.0877 113.781 55.9588C113.781 53.8298 101.383 52.104 86.0879 52.104C70.7933 52.104 58.3946 53.8298 58.3946 55.9588C58.3946 58.0877 70.7933 59.8135 86.0879 59.8135Z",
    fill: "#EF8B06"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.818 140.966H40L44.1929 106.409C44.8692 100.999 48.3182 96.2985 53.3226 94.1006C59.95 91.2265 69.1812 88.2847 77.364 86.053L95.9953 85.9854C104.246 88.217 113.206 91.1588 119.631 94.0668C124.534 96.2985 127.915 100.931 128.592 106.274L132.818 140.966Z",
    fill: "#EAEAEA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4348 77.0923V86.3234C96.4348 86.3234 94.6089 96.6365 86.054 98.361C77.1273 96.0279 75.7747 86.3234 75.7747 86.3234V77.0923H96.4348Z",
    fill: "#F7CFA4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M105.024 65.0547C107.321 65.0547 109.183 62.8142 109.183 60.0503C109.183 57.2864 107.321 55.0459 105.024 55.0459C102.727 55.0459 100.864 57.2864 100.864 60.0503C100.864 62.8142 102.727 65.0547 105.024 65.0547Z",
    fill: "#F7CFA4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7609 64.649C70.0579 64.649 71.92 62.4084 71.92 59.6445C71.92 56.8807 70.0579 54.6401 67.7609 54.6401C65.4639 54.6401 63.6018 56.8807 63.6018 59.6445C63.6018 62.4084 65.4639 64.649 67.7609 64.649Z",
    fill: "#F7CFA4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7747 81.1839C78.7165 84.3961 82.3346 86.5264 86.2231 86.5264C90.0102 86.5264 93.5269 84.4976 96.4348 81.4205V77.1262H75.7747V81.1839Z",
    fill: "#E2AA6D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68.133 53.4565V60.0502C68.133 70.059 76.2483 84.1931 86.2571 84.1931C96.2659 84.1931 104.381 70.059 104.381 60.0502V53.4565H68.133Z",
    fill: "#F7CFA4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.757 113.611H56.0276V141H116.757V113.611Z",
    fill: "#FFB600"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.458 122.335H65.3264V140.966H107.458V122.335Z",
    fill: "#FF8B00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0316 113.611V88.7917C65.4617 89.6033 62.9257 90.4486 60.5249 91.294V113.611H68.0316Z",
    fill: "#FFB600"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M112.496 113.611V91.1926C110.096 90.3135 107.56 89.4343 104.99 88.6228V113.611H112.496Z",
    fill: "#FFB600"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4623 55.7221H113.917C113.342 54.9782 110.941 51.935 108.439 50.9206C108.439 50.9206 109.622 26.5072 86.257 26H86.2232H86.1894C62.8242 26.5072 64.0077 50.9206 64.0077 50.9206C61.4041 51.935 59.0033 54.9782 58.4623 55.7221Z",
    fill: "#FFB600"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40.4674V44.7717H86.2283V48L91.7283 42.5H88.3804L94 37L83 40.4674Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.99988,
    y: 101,
    width: 167,
    height: 50,
    fill: "url(#paint4_linear_5140_23626)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5140_23626",
    x1: 36.6411,
    y1: 79,
    x2: 36.6411,
    y2: 105.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5140_23626",
    x1: 36.6316,
    y1: 94.5874,
    x2: 36.6316,
    y2: 107.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5140_23626",
    x1: 136.641,
    y1: 79,
    x2: 136.641,
    y2: 105.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5140_23626",
    x1: 136.632,
    y1: 94.5874,
    x2: 136.632,
    y2: 107.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5140_23626",
    x1: 87.4999,
    y1: 101,
    x2: 87.4999,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinemanGroup);
export default __webpack_public_path__ + "static/media/linemanGroup.03fe75c33dea2358ae51a525ec35ca1d.svg";
export { ForwardRef as ReactComponent };